// SignInGate — shown where an account page needs a signed-in session (task 175): business owners and
// waiters prove the connected wallet is theirs by signing a message (free, no transaction). Payers never
// see this. Owns its CSS so it renders the same inside Settings and on guarded routes like /queue.

import type { JSX } from 'react';
import { useWallet } from '../contexts/WalletContext.tsx';
import { truncateAddress } from '../domain/format.ts';
import './SignInGate.css';

export const SignInGate = ({ onDisconnect }: Readonly<{ readonly onDisconnect?: () => void }>): JSX.Element => {
  const { state, connectedWallet, signIn, canSignIn } = useWallet();
  const who = connectedWallet?.handle ?? (connectedWallet !== null ? truncateAddress(connectedWallet.address, 6, 4) : null);

  return (
    <div className="sign-in-gate">
      <h3 className="sign-in-gate-title">Sign in to your account</h3>
      {who !== null && <p className="sign-in-gate-who">{who}</p>}
      <p className="sign-in-gate-text">
        Business owners and staff sign a short message in their wallet to prove it&apos;s theirs.
        It&apos;s free and doesn&apos;t send a transaction.
      </p>
      {canSignIn ? (
        <button className="sign-in-gate-btn" onClick={signIn} disabled={state.signingIn} type="button">
          {state.signingIn ? 'Check your wallet…' : 'Sign in with wallet'}
        </button>
      ) : (
        <p className="sign-in-gate-text" role="status">Signing in needs an Ethereum-compatible (EVM) wallet.</p>
      )}
      {state.signInError !== null && <p className="sign-in-gate-error" role="alert">{state.signInError}</p>}
      {onDisconnect !== undefined && (
        <button className="sign-in-gate-link" onClick={onDisconnect} type="button">Use a different wallet</button>
      )}
    </div>
  );
};
